import envConfig from '../utils/getEnv';

const { apiVersions } = envConfig;

export const REFRESH_NEEDED = 'REFRESH_NEEDED';
export const RECENTLY_VIEWED_MAX_DAYS = 3;
export const DELIMITER = '_=_';
export const CATEGORY_CODE_DELIMITER = '#==#';

export const MAX_LENGTH_OF_INPUT = 32;
export const MAX_LENGTH_OF_JSON = 800000;

export const defaultDays = 90;
export const offsetDays = 179; // Considering today into consideration, allowing total of 180 days to be selected by the user
export const defaultDaysForSiteSummaryDialog = 90; // test with 90 to verify data display

export const unitCategory = Object.freeze({
  unit1: 'unit1',
  unit2: 'unit2',
});

export const NOT_AVAILABLE = 'NA';

export const denoTypes = ['ONB_ASSET_COUNT', 'CONN_SITE_COUNT'];

export const exludedCategoryForIndividualEquipment = 'VAV';
export const siteCombicodeRowCount = 3;

export const hashSplit = '####';
export const Reset = 'reset';
export const divElement = 'divElement';
export const tempConsump = 'tempConsump';

export const getGroupParam = groupId => `grpId=${groupId}`;

export const ALL_INFO_FILTER_PROFILE = 'ALL_INFO';

export const limitCount = 6;

export const uomMap = {
  TEMPERATURE: 'CENTIGRADE',
  'DIFFERENTIAL TEMPERATURE': 'CENTIGRADE',
  'FLOW LIQUID': 'LPS',
  PRESSURE: 'KILOPASACAL',
};

export const assetRowsCollapseTimeout = 200;

// Virtualized to-do list grouped by asset category (SiteDetails).
export const assetCategoryRowDefaultHeight = 220;
export const assetCategoryRowOverscanCount = 2;

export const equipCategory = 'equipCategory';
export const remote = 'remote';
export const field = 'field';
export const includeWorkOrderAndEvents = 'includeWorkOrderAndEvents';

export const STTMP_TEXT = 'STTMP';

export const TMM_CONSTANT = {
  TMMSTD: 'TMMSTD',
  TMMAGENT: 'TMMAGENT',
  TMMConfigPayload: {
    service: 'tmm-service-external',
    version: apiVersions.tmmConfig,
    key: 'tmm.acatcodes.enabled',
  },
};

// export const EULA_LINK = 'https://cortix.ai/public/CORTIX%20EULA%20031121.htm';
